import React from 'react'
import {faCalendarAlt} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"

export default class CalendarAltInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showing: false
    }
    this.handleClick = this.handleClick.bind(this)
    this.hide = this.hide.bind(this)
  }

  show() {
    this.setState({showing: true}, () => {
      document.addEventListener("click", this.hide)
      this.props.onClick()
    })
  }

  hide() {
    this.setState({showing: false}, () => document.removeEventListener("click", this.hide))
  }

  handleClick() {
    if (this.state.showing) this.hide()
    else this.show()
  }

  render() {
    return (<div onClick={this.handleClick}><FontAwesomeIcon icon={faCalendarAlt} /></div>)
  }

}
